export const IS_DEV = process.env.NODE_ENV === 'development'
export const WS_URL = process.env.REACT_APP_WSS_URL
export const BASE_URL = process.env.REACT_APP_API_BASE_URL
export const GRAPH_QL_BASE_URL = `${BASE_URL}/api/graphql`
